import { Button } from "~/components/ui/button";
import { cn } from "~/utils/cn";

interface ChatSuggestionChipProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export function ChatSuggestionChip({ label, onClick, disabled, className }: ChatSuggestionChipProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={disabled}
      onClick={onClick}
      className={cn("h-auto rounded-full px-3 py-1.5 text-xs font-normal whitespace-normal", className)}
    >
      {label}
    </Button>
  );
}
